import type { MsgStatus } from '../lib/messageStatus';

// Единая точка замены временных значков на SVG владельца.
const statusPaths = {
  waiting: 'M8 4v4l3 2M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1',
  single: 'M2 8l4 4L14 4',
  double: 'M1 8l4 4L13 4M9 10l2 2L19 4',
};

export default function MessageStatusIcon({ status }: { status: MsgStatus | 'waiting' }) {
  const state = status === 'waiting' ? 'waiting' : status === 'read' ? 'double' : 'single';
  return (
    <svg aria-hidden="true" className="msg-status-icon" data-status-icon={state} viewBox="0 0 20 16" width="20" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d={statusPaths[state]} />
    </svg>
  );
}
